
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/transfer/creating-transfers",
      function () {
        return require("private-next-pages/docs/transfer/creating-transfers.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/transfer/creating-transfers"])
      });
    }
  